<button
  class="filter-btn"
  [class.filter-btn--sm]="size() === 'sm'"
  [class.filter-btn--md]="size() === 'md'"
  [class.filter-btn--lg]="size() === 'lg'"
  [class.filter-btn--active]="hasActiveFilters()"
  (click)="onClick($event)"
>
  <mat-icon class="filter-icon">filter_list</mat-icon>
  @if (hasActiveFilters()) {
    <span class="filter-badge"></span>
  }
</button>
